import { ExternalAuthErrorCode } from '@account/account-portal/external-auth'

const knownErrors: ExternalAuthErrorCode[] = [
  'CEXT-KR-CI_ALREADY_EXISTS',
  'CI_NOT_VALID',
  'EMAIL_NOT_VALID',
  'TOKEN_NOT_VALID',
  'PHONENUMBER_NOT_VALID',
  'CI_NOT_MATCHING',
  'PHONE_NUMBER_NOT_MATCHING',
  'PHONE_NUMBER_ALREADY_EXIST',
  'TELEPHONENUMBER_ALREADY_EXISTS',
  'CI_NOT_MATCHING,PHONE_NUMBER_NOT_MATCHING', // Combination of errors via comma
]

export const isKnownError = (erorCode: ExternalAuthErrorCode) => knownErrors.includes(erorCode)

export const UNKNOWN_ERROR = 'UNKNOWN'
